import type { filtersType } from '../../components/v2/filters/interfaces'

export const getFilters = ({
  currentFilters,
  availableFilters,
  isGoLeader,
  isBrandLeader,
}): filtersType[] => {
  const filters: filtersType[] = [
    {
      name: 'phone',
      label: 'Телефон',
      type: 'phone',
      value: currentFilters?.phone,
    },
    {
      name: 'line_number',
      label: 'Номер Манго',
      type: 'select',
      value: currentFilters?.line_number,
      options: {
        enum: availableFilters?.line_number,
      },
    },
    {
      name: 'date',
      label: 'Дата',
      type: 'dates',
      value: currentFilters?.date,
    },
    {
      name: 'office_id',
      label: 'Офис',
      type: 'select',
      value: currentFilters?.office_id,
      options: {
        enum: availableFilters?.office_id,
      },
    },
    {
      name: 'brand_id',
      label: 'Бренд',
      type: 'select',
      value: currentFilters?.brand_id,
      options: {
        enum: availableFilters?.brand_id,
      },
    },
    {
      name: 'manager_id',
      label: 'Менеджер',
      type: 'select',
      value: currentFilters?.manager_id,
      options: {
        enum: availableFilters?.manager_id,
      },
    },
  ]

  return filters.filter(filter => {
    if (isBrandLeader && filter.name === 'brand_id') return false
    return !(
      !isBrandLeader &&
      !isGoLeader &&
      (filter.name === 'brand_id' || filter.name === 'office_id')
    )
  })
}
